import { getGraphHeaders } from '@/utils/getGraphHeaders';

import type { BffBrandType } from '@/graphql/__generated/sdk';

export const getBffOneTrustProxy = async <T = unknown>(
	variables: { brand: BffBrandType; payload: unknown },
	url: string,
	appName: string,
	appVersion: string
): Promise<T> => {
	try {
		const { getGraphQLClient } = await import(
			/* webpackChunkName:"getGraphQLClient" */ '../graphql/getGraphQLClient'
		);
		const client = getGraphQLClient(url);

		const result = (await client.ConsentManagement(variables, getGraphHeaders(appName, appVersion))) as T;

		return result;
	} catch (err) {
		console.error('OneTrust Proxy - Request failed:', err);
		throw err;
	}
};

export type ConsentPurpose =
	| 'Marketing_SMS'
	| 'Transactional_SMS'
	| 'Marketing_Email'
	| 'Transactional_Email'
	| 'Outbound_Calling';

export interface PurposeConsent {
	Id: string;
	TransactionType: 'CONFIRMED' | 'NOTGIVEN';
	ConsentType: 'IMPLICIT' | 'EXPLICIT';
	DOI?: 'YES' | 'NO';
}

/**
 * Builds the purposes array for OneTrust consent.
 * @param opts - Checkbox values for each consent type.
 */
export function buildPurposes(opts: { sms_marketing: boolean; sms_transactional: boolean }): PurposeConsent[] {
	return [
		// Transactional Email (IMPLICIT, always CONFIRMED)
		{
			Id: 'Transactional_Email',
			TransactionType: 'CONFIRMED',
			ConsentType: 'IMPLICIT',
		},
		// Marketing Email (IMPLICIT, always CONFIRMED)
		{
			Id: 'Marketing_Email',
			TransactionType: 'CONFIRMED',
			ConsentType: 'IMPLICIT',
		},
		// Outbound Calling (IMPLICIT, always CONFIRMED)
		{
			Id: 'Outbound_Calling',
			TransactionType: 'CONFIRMED',
			ConsentType: 'IMPLICIT',
		},
		// Transactional SMS (EXPLICIT)
		{
			Id: 'Transactional_SMS',
			TransactionType: opts.sms_transactional ? 'CONFIRMED' : 'NOTGIVEN',
			ConsentType: 'EXPLICIT',
			DOI: 'YES',
		},
		// Marketing SMS (EXPLICIT)
		{
			Id: 'Marketing_SMS',
			TransactionType: opts.sms_marketing ? 'CONFIRMED' : 'NOTGIVEN',
			ConsentType: 'EXPLICIT',
			DOI: 'YES',
		},
	];
}
